import { BrandAsset, BrandAssetParams, BrandAssetResult } from './types';
import { globalGetService, globalPostService } from '@/utils/globalApiServices';

export const verifyAsset = async (brandId: string, assetName: string) => {
  const response = await globalPostService(
    `csp/brands/${brandId}/asset/${assetName}/verify`
  );
  return response?.ok ? response.data : undefined;
};

export const getBrandAssets = async (
  brandUid: string,
  params: BrandAssetParams = {},
  silent = false
): Promise<BrandAsset[]> => {
  const response = await globalGetService(
    `csp/brands/${brandUid}/asset`,
    params,
    { silent }
  );
  return response?.ok ? (response.data as BrandAsset[]) : [];
};

export const registerBrandAsset = async (
  brandUid: string,
  brandAssetType: string,
  name: string,
  attachmentUuid: string
) => {
  const response = await globalPostService(`csp/brands/${brandUid}/asset`, {
    brandAssetType,
    name,
    attachmentUuid,
  });
  return response?.ok ? (response.data as BrandAssetResult) : undefined;
};
